import React from "react";
import Typography from "@material-ui/core/Typography";
import { CardContent, Divider, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { fbdb } from "../AppClass";
import { AppContext } from "../App";
import { LinearProgress } from "@material-ui/core/es";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

class SupportPage extends React.Component {
  state = {
    words: ["", "", "", "", ""],
    sentences_pair: [
      { asm: "", eng: "" },
      { asm: "", eng: "" },
      { asm: "", eng: "" },
      { asm: "", eng: "" },
      { asm: "", eng: "" }
    ],
    reportText: "",
    submitting: false
  };

  changeData = (e, index) => {
    let changes = this.state.words;
    changes[index] = e.currentTarget.value;
    this.setState({ words: changes });

    console.log(this.state.words);
  };

  changeSentenceData = (e, rownum, column_num) => {
    let changes = this.state.sentences_pair;
    changes[rownum][column_num] = e.currentTarget.value;
    this.setState({ sentences_pair: changes });

    console.log(this.state.sentences_pair);
  };

  sendReport = contextAction => {
    let self = this;
    const auth_token = localStorage.getItem("auth_token");

    if (this.state.reportText.length < 1) {
      contextAction.openSnackBar("Please write report.");
      return;
    }

    this.setState({ submitting: true });

    // Add a new document with a generated id.
    fbdb
      .collection("reports")
      .add({
        id: auth_token,
        report: this.state.reportText,
        time: new Date()
      })
      .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        contextAction.openSnackBar("Report submitted successfully.");

        self.setState({ submitting: false });
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
        self.setState({ submitting: false });
      });
  };

  sendSentences = contextAction => {
    let self = this;
    const auth_token = localStorage.getItem("auth_token");

    let valid_sentences_pair = [];

    this.state.sentences_pair.map(value => {
      //console.log(value)
      {
        self.isDataValid(value.asm) &&
          self.isDataValid(value.eng) &&
          valid_sentences_pair.push(value);
      }
    });

    if (valid_sentences_pair.length < 1) {
      contextAction.openSnackBar("Invalid data.");
      return;
    }

    this.setState({ submitting: true });

    // Add a new document with a generated id.
    fbdb
      .collection("translations")
      .add({
        id: auth_token,
        //sentences: self.state.sentences_pair,
        sentences: valid_sentences_pair
      })
      .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        contextAction.openSnackBar("Translations submitted successfully.");

        self.setState({ submitting: false });
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
        self.setState({ submitting: false });
      });
  };

  isDataValid = _string => {
    if (_string.length < 2) {
      return false;
    } else {
      return true;
    }
  };

  submitWords = contextAction => {
    let self = this;
    const auth_token = localStorage.getItem("auth_token");

    let valid_words = [];

    this.state.words.map(value => {
      //console.log(value)
      {
        self.isDataValid(value) && valid_words.push(value);
      }
    });

    if (valid_words.length < 1) {
      contextAction.openSnackBar("Invalid data.");
      return;
    }

    this.setState({ submitting: true });

    // Add a new document with a generated id.
    fbdb
      .collection("words")
      .add({
        id: auth_token,
        //words: self.state.words
        words: valid_words
      })
      .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        contextAction.openSnackBar("Words submitted successfully.");

        self.setState({ submitting: false });
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
        self.setState({ submitting: false });
      });
  };

  onReportType = e => {
    this.setState({ reportText: e.currentTarget.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            <div className="padding10">
              <Typography variant={"h5"} gutterBottom color="textSecondary">
                Develop Aakhor
              </Typography>

              <Typography variant="body1" gutterBottom color="textSecondary">
                Help us develop Aakhor. Submit content to system.
              </Typography>
            </div>

            <div className="dividerMargin" />

            <div className={classes.root}>
              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    Submit new words
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    <Typography>
                      Submit new words to our 6,00,000+ words dataset.
                    </Typography>

                    {this.state.words.map((value, index) => {
                      return (
                        <TextField
                          key={index}
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          onChange={e => {
                            this.changeData(e, index);
                          }}
                          placeholder="Type Assamese word"
                        />
                      );
                    })}
                    <div className="marginTop10" />
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={this.state.submitting}
                      onClick={() => this.submitWords(actions)}
                    >
                      submit words
                    </Button>
                    <Button
                      color={"primary"}
                      size="small"
                      onClick={() => {
                        this.setState({
                          words: [...this.state.words, ""]
                        });
                      }}
                    >
                      + Add more
                    </Button>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    Submit translation
                  </Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <div className={classes.root}>
                    <Typography>
                      Submit Assamese - English sentence pair for our upcoming
                      translator application.
                    </Typography>

                    {this.state.sentences_pair.map((value, index) => {
                      return (
                        <div className={classes.root} key={index}>
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <TextField
                                key={index}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                placeholder="Assamese sentence"
                                value={value.asm}
                                onChange={e => {
                                  this.changeSentenceData(e, index, "asm");
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                key={index}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                placeholder="English sentence"
                                value={value.eng}
                                onChange={e => {
                                  this.changeSentenceData(e, index, "eng");
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      );
                    })}
                    <div className="marginTop10" />
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={this.state.submitting}
                      onClick={() => this.sendSentences(actions)}
                    >
                      submit sentences
                    </Button>
                    <Button
                      color={"primary"}
                      size="small"
                      onClick={() => {
                        this.setState({
                          sentences_pair: [
                            ...this.state.sentences_pair,
                            { asm: "", eng: "" }
                          ]
                        });
                      }}
                    >
                      + Add more
                    </Button>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    Report an error
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className={classes.root}>
                    <Typography>
                      Anything wrong with our application? Please let us know.
                    </Typography>

                    <TextField
                      fullWidth
                      label="Report an error"
                      variant="outlined"
                      margin="normal"
                      multiline
                      error
                      value={this.state.reportText}
                      onChange={e => this.onReportType(e)}
                    />
                    <div className="marginTop10" />
                    <Button
                      variant="contained"
                      color="secondary"
                      disabled={this.state.submitting}
                      onClick={() => this.sendReport(actions)}
                    >
                      Report error
                    </Button>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>

            <div className="dividerMargin" />
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

SupportPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SupportPage);
